import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getBillingTariffs } from "../../../apiCalls/admin/billing_tariffs";
import { BillingTariffInterface } from "../../../interfaces/BillingTarifInterface";
import { processTariff } from "../../orgSettings/InternalBillingTariffs/dataHandlers";

export const useBillingTariffs = () => {
  const company = useSelector(
    (state: any) => state.customer.currentCustomer?.shortname,
  );
  const [tariffs, setTariffs] = useState([] as BillingTariffInterface[]);
  const { CancelToken } = axios;

  const fetchTariffs = (customer: string) => {
    const source = CancelToken.source();
    const sourceToken = source.token;
    getBillingTariffs(1, "", sourceToken).then((res) => {
      if (!res || !res?.data) {
        setTariffs([]);
      }
      const {
        data: { data },
      } = res;
      const data_per_company = data.map((x) => processTariff(customer, x));
      setTariffs(data_per_company);
    });
  };

  useEffect(() => fetchTariffs(company), []);

  const getTariffByLicenseNumber = useCallback(
    (license: number) =>
      tariffs.find((t) => t.license === license)?.data?.name || "",
    [tariffs],
  );

  return { tariffs, getTariffByLicenseNumber };
};
